"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Overlay_1 = __importDefault(require("react-bootstrap/Overlay"));
var Tooltip_1 = __importDefault(require("react-bootstrap/Tooltip"));
var icon_library_enum_1 = __importDefault(require("../../shared/enums/icon-library.enum"));
var icon_enum_1 = __importDefault(require("../../shared/enums/icon.enum"));
var size_enum_1 = __importDefault(require("../../shared/enums/size.enum"));
var eventHelper_1 = __importDefault(require("../../shared/utilities/eventHelper"));
var branded_text_1 = __importDefault(require("../branded-text"));
var icon_1 = __importDefault(require("../icon"));
require("./logo-text.scss");
var utility_1 = require("./utility");
function LogoText(props) {
    var spanRef = (0, react_1.useRef)(null);
    var divRef = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(false), showTooltip = _a[0], setShowTooltip = _a[1];
    var _b = (0, react_1.useState)(false), showOverflowIcon = _b[0], setShowOverflowIcon = _b[1];
    var isMounted = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        var handleOverflowIcon = function () {
            if (isMounted.current) {
                if ((0, utility_1.textOverflowsTheSpace)(spanRef)) {
                    setShowOverflowIcon(true);
                }
                else {
                    setShowOverflowIcon(false);
                }
            }
        };
        var handleAddEventListener = function () {
            window.addEventListener("resize", function () {
                handleOverflowIcon();
            });
        };
        isMounted.current = true;
        if (props.type === "custom") {
            handleOverflowIcon();
            handleAddEventListener();
        }
        return function () {
            window.removeEventListener("resize", function () {
                handleOverflowIcon();
            });
            isMounted.current = false;
        };
    }, [spanRef, props.type]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { ref: spanRef, className: "mpng-ux-logo-text" }, props.type && props.type !== "custom" ? (react_1.default.createElement(branded_text_1.default, { registered: props.registered })) : (react_1.default.createElement("span", { role: "heading", "aria-level": 1, className: "".concat(props.title ? "logo-text-custom" : "", " ").concat(props.logoClassName ? "text-primary" : "", " ").concat(props.icon ? "with-icon-header" : "") },
            props.title,
            props.registered && react_1.default.createElement("span", { className: "text-xxs text-super" }, "\u00AE")))),
        showOverflowIcon && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", __assign({ ref: divRef, className: "overflow-icon" }, (0, eventHelper_1.default)(function () { return setShowTooltip(!showTooltip); })),
                react_1.default.createElement(icon_1.default, { title: props.title, icon: icon_enum_1.default.INFO_CIRCLE, size: size_enum_1.default.SMALL, squared: true, library: icon_library_enum_1.default.DUOTONE, className: "text-primary text-xxs text-super" })),
            react_1.default.createElement(Overlay_1.default, { target: divRef.current, show: showTooltip, placement: "bottom", rootClose: true },
                react_1.default.createElement(Tooltip_1.default, { id: "overflow-text" }, props.title))))));
}
exports.default = LogoText;
